/*
 * Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

// import { getDefaultSchemaFieldImpl } from "cms/fields/get-default-field-impl";
// import { initializeField } from "cms/fields/transformers/initialize-field";
import createCachedSelector from "re-reselect";
import { createDeepEqualSelector } from "data/store/create-deep-equal-selector";


/**
 * @param {RootState} state
 */
export function selectCurrentEntity (state) {
    return state.entity.current;
}

/**
 * @param {RootState} state
 */
export function selectEntityLoading (state) {
    return state.entity.loading;
}

/**
 * @param {RootState} state
 */
export function selectCurrentEntityType (state) {
    return state.entity.current?.type;
}

/**
 * @param {RootState} state
 */
export function selectHasCurrentEntity (state) {
    return !!state.entity.current;
}

/**
 * @param {RootState} state
 * @returns {any[]}
 */
export function selectCurrentAttrs (state) {
    return state.entity.current?.attrs || [];
}

/**
 * @param {RootState} state
 * @returns {any[]}
 */
export function selectEntitySchemas (state) {
    return state.entity.schema.all || [];
}

export const selectAttributeByPosition = createCachedSelector(
    // Performance: uses re-reselect to cache the work done by the selector when the input is the same
    
    selectEntitySchemas,
    
    selectCurrentEntityType,
    
    selectCurrentAttrs,
    
    /**
     * 
     * @param {RootState} state 
     * @param {number} position 
     * @returns 
     */
    (state, position) => position,
    (schemas, type, attrs, position) => {

        if (!attrs || attrs.length === 0) {
            return null;
        }
        // get one entity schema from all entity schemas
        const schema = schemas.find((element) => {
            return element.type === type;
        });

        // get one attr for the current attribute name
        const attr = attrs[position];
        const schemaAttr = schema.attrs.find((attrSchema) => {
            return attrSchema?.name === attr?.name;
        });
        if (!schemaAttr) {
            return null;
        }
        const positionAttr = attrs.find((attr) => {
            return attr?.name === schemaAttr?.name;
        });
        // TODO use scheama to initialize a new attr
        const initAttr = {};
        return positionAttr ?? initAttr;
    }
)(
    {
        keySelector (state, position) {
            const guid = state.entity.current?.guid;
            const key = [guid, "attr", position].join(":");

            return key;
        },
        selectorCreator: createDeepEqualSelector
    }
);

export const selectCurrentAttrInfo = createDeepEqualSelector(
    selectCurrentAttrs,
    /**
     * @returns {Array<{type: string, name: string}>}
     */
    (attrs) => attrs.map((attr) => {
        return {
            type: attr.type,
            name: attr.name,
        };
    })
);


/**
 * @typedef {import("./entity.state")["entityState"]} EntityState
 */

/**
 * @typedef {object} RootState
 * @property {EntityState} entity
 */
